import request from './request'
import { CORE_IDEA_WORK_URL, CORE_IDEA_WORK_UPLOAD_URL, WORK_TASK_QUERY_URL } from './config'

export function createCoreIdeaByText (payload) {
  return request.post(CORE_IDEA_WORK_URL, payload)
}

export function uploadCoreIdeaFile (formData, config) {
  return request.post(CORE_IDEA_WORK_UPLOAD_URL, formData, config)
}

export function queryWorkTask (taskId) {
  return request.post(WORK_TASK_QUERY_URL, { taskId })
}

